// extracted by css-extract-rspack-plugin
export default {"card":"index__card___NHbB8"};